import { useContext } from "react";
import SPQSUndoContext from "../contexts/SPQSUndoProvider";

const useSPQSUndo = () => {
  return useContext(SPQSUndoContext);
};

export default useSPQSUndo;
